<template>
  <div class="chat-wrapper">
    <div class="chat-container">
      <loading-messages v-if="loading"></loading-messages>
      <div class="messages" ref="messages">
        <div ref="messagesCont">
          <template v-if="!loading && messages && messages.length > 0">
            <template v-for="message in messages">
              <item
                v-if="message"
                :key="message.id"
                :value="message"
                :is-mine="isMe(message)"
                :author="author(message)"
              ></item>
            </template>
          </template>
        </div>
      </div>
    </div>
    <chat-input v-if="!loading && chat" :value="chat.id"></chat-input>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Item from "@/components/Messages/Item";
import ChatInput from "@/components/ChatInput";
import LoadingMessages from "@/components/Loadings/Message";
import Fetch from "@/mixins/Fetch";
export default {
  mixins: [Fetch],
  components: {
    Item,
    ChatInput,
    LoadingMessages
  },
  metaInfo: {
    title: "Chat"
  },
  data() {
    return {
      user: null,
      loading: false,
      offset: 0,
      limit: 30,
      height: 0
    };
  },
  computed: {
    ...mapGetters({
      messages: "message/messages",
      chatById: "chat/byId",
      authType: "auth/type",
      authUser: "auth/user",
      authLocale: "auth/locale"
    }),
    chat() {
      return this.chatById(this.$route.params.id);
    },
    me() {
      if (!this.authUser) {
        return null;
      }
      return {
        id: this.authUser.id,
        name: `${this.authUser.firstname[this.authLocale]} ${
          this.authUser.lastname[this.authLocale]
        }`,
        avatar: this.authUser.photo
      };
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.id !== to.params.id) {
      this.resetMessages();
      this.resetHead();
      this.fetchChat(to.params.id, this.chatInit);
      this.setCurrentChatId(to.params.id);
      this.fetch(to.params.id, () => {
        next();
      });
    }
  },
  created() {
    const interval = setInterval(() => {
      if (this.$refs && this.$refs.messages && this.$refs.messagesCont) {
        this.$refs.messages.addEventListener("scroll", this.handleScroll);
        new ResizeObserver(() => {
          if (!this.$refs.messages) {
            return;
          }
          if (this.height === 0) {
            this.$refs.messages.scrollTo(0, this.$refs.messages.scrollHeight);
          } else if (
            this.$refs.messagesCont.clientHeight -
              this.$refs.messages.scrollTop -
              this.$refs.messages.clientHeight <
            300
          ) {
            this.$refs.messages.scrollTo(0, this.$refs.messages.scrollHeight);
          } else {
            this.$refs.messages.scrollTo(
              0,
              this.$refs.messages.scrollHeight - this.height + 50
            );
          }
        }).observe(this.$refs.messagesCont);
        clearInterval(interval);
      }
    }, 200);
  },
  mounted() {
    this.setNavVisible(false);
    if (this.$route.params.id) {
      this.resetMessages();
      this.fetchChat(this.$route.params.id, this.chatInit);
      this.fetch(this.$route.params.id);
      this.setCurrentChatId(this.$route.params.id);
      this.setSeen(this.$route.params.id);
      // const interval = setInterval(() => {
      //   if (this.$refs.messages) {
      //     this.$refs.messages.scrollTo(0, this.$refs.messages.scrollHeight)
      //     clearInterval(interval)
      //   }
      // }, 300)
    }
    // setTimeout(() => {
    //       const messagesContainer = this.$refs.messages
    //       messagesContainer.scrollTo(0, messagesContainer.scrollHeight)
    //     }, 500)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    this.setCurrentChatId(null);
    this.resetMessages();
    this.resetHead();
  },
  methods: {
    ...mapMutations({
      setMessages: "message/setMessages",
      unshiftMessage: "message/unshift",
      resetMessages: "message/reset",
      // reset: 'message/reset',
      setError: "alert/setError",
      setHead: "head/set",
      resetHead: "head/reset",
      setCurrentChatId: "app/setChatId",
      setNavVisible: "app/setNavVisible"
    }),
    ...mapActions({
      setSeen: "chat/seen"
    }),
    handleScroll() {
      if (this.$refs.messages && this.$refs.messages.scrollTop === 0) {
        this.offset = this.messages.length;
        this.fetch(this.$route.params.id);
      }
    },
    isMe(message) {
      if (this.authUser && message.created_by === this.authUser.id) {
        return true;
      }
      return false;
    },
    author(message) {
      if (this.user && message.created_by === this.user.id) {
        return this.user;
      }
      return this.me;
    },
    async fetch(id, callback) {
      if (this.$refs.messagesCont) {
        this.height = this.$refs.messagesCont.clientHeight;
      }
      this.loading = true;
      try {
        const params = { limit: this.limit, offset: this.offset };
        const response = await this.axios.get(
          `/api/chat-spaces/${id}/messages`,
          { params }
        );
        const messages = response.data.data;
        for (const m of messages) {
          this.unshiftMessage(m);
        }
        // this.setMessages(messages)
        this.loading = false;
        if (callback) {
          callback();
        }
      } catch (err) {
        this.setError(err);
        this.loading = false;
      }
    },
    async chatInit(chat) {
      try {
        if (chat.type === "PatientClinic" && this.authType === "Patient") {
          await this.fetchClinic(chat.chat_space.clinic_id, (clinic) => {
            this.user = {
              id: clinic.id,
              name: clinic.name,
              avatar: clinic.logo
            };
            this.setHead({
              url: "/chats",
              text: this.user.name,
              photo: this.user.avatar
            });
          });
        } else {
          if (this.authType === "Patient") {
            await this.fetchUser(chat.chat_space.doctor_id, (user) => {
              this.user = user;
              this.setHead({
                url: "/chats",
                text: this.user.name,
                photo: this.user.avatar,
                user: this.user
              });
            });
          } else {
            if (chat.type === "DoctorClinic") {
              if (this.authType === "Doctor") {
                this.user = {
                  id: chat.chat_space.current_operator.id,
                  name: `${
                    chat.chat_space.current_operator.firstname[this.authLocale]
                  } ${
                    chat.chat_space.current_operator.lastname[this.authLocale]
                  }`,
                  avatar: chat.chat_space.current_operator.photo
                };
                this.setHead({
                  url: "/chats",
                  text: this.user.name,
                  photo: this.user.avatar,
                  user: this.user
                });
              } else {
                this.user = {
                  id: chat.chat_space.doctor.id,
                  name: `${chat.chat_space.doctor.firstname[this.authLocale]} ${
                    chat.chat_space.doctor.lastname[this.authLocale]
                  }`,
                  avatar: chat.chat_space.doctor.photo
                };
                this.setHead({
                  url: "/chats",
                  text: this.user.name,
                  photo: this.user.avatar,
                  user: this.user
                });
              }
            } else {
              this.user = {
                id: chat.chat_space.patient.id,
                name: `${chat.chat_space.patient.firstname[this.authLocale]} ${
                  chat.chat_space.patient.lastname[this.authLocale]
                }`,
                avatar: chat.chat_space.patient.photo,
                age: chat.chat_space.patient.age,
                age_unit: chat.chat_space.patient.age_unit,
                gender: chat.chat_space.patient.gender,
                parent: chat.chat_space.patient.parent,
                parent_name: (chat.chat_space.patient.parent?`${chat.chat_space.patient.parent.firstname[this.authLocale]} ${chat.chat_space.patient.parent.lastname[this.authLocale]}`:null),
              };
              // {{ user.age }} {{ $t(user.age_unit) }} | {{ $t(user.gender) }} <span v-if="user.parent_name">| მშობელი: {{user.parent_name}}</span>
              this.setHead({
                url: "/chats",
                text: this.user.name,
                subText: `${this.user.age} ${this.$t(this.user.age_unit)} | ${this.$t(this.user.gender)}` + (this.user.parent_name?` | მშობელი: ${this.user.parent_name}`:''),
                photo: this.user.avatar,
                user: this.user
              });
            }
          }
        }
      } catch (err) {
        this.setError(err);
      }
    }
  }
};
</script>
<style lang="scss">
.chat-wrapper {
  height: 100%;
  //   margin-top: -58px;
  //   position: relative;
  //   overflow: hidden;
  //   padding-top: 58px;
  .chat-container {
    height: calc(100% - 48px);
    // display: flex;
    // position: relative;
    // flex-direction: column-reverse;
    // display: flex;
    // flex-direction: column-reverse;
    .messages {
      overflow-y: auto;
      height: 100%;
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "year": "წლის",
    "month": "თვის",
    "male": "მამრობითი",
    "female": "მდედრობითი"
  },
  "en": {
    "year": "years old",
    "month": "months old",
    "male": "male",
    "female": "female"
  }
}
</i18n>
